import { Exclude } from 'class-transformer';
import {
  ArrayNotEmpty,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { BaseCreateDto, BaseUpdateDto } from './base.dto';
import { JurisdictionalGroupDto } from './jurisdictional-group.dtos';
import { MedicalUnitDto } from './medical-unit.dtos';

export interface MedicalUnitGroupDto {
  id: string;
  jurisdictionalGroupId: string;
  jurisdictionalGroup: JurisdictionalGroupDto;
  name: string;
  description?: string;
  isDefaultGroup: boolean;
  medicalUnits?: MedicalUnitDto[];
}

export class CreateMedicalUnitGroupDto
  extends BaseCreateDto
  implements Partial<MedicalUnitGroupDto>
{
  @IsUUID()
  jurisdictionalGroupId: string;

  @Exclude()
  jurisdictionalGroup?: never;

  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  description?: string;

  @IsUUID('all', { each: true })
  @ArrayNotEmpty()
  medicalUnitIds: string[];

  @Exclude()
  isDefaultGroup?: never;

  @Exclude()
  medicalUnits?: never;
}

export class UpdateMedicalUnitGroupDto
  extends BaseUpdateDto
  implements Partial<MedicalUnitGroupDto>
{
  @Exclude()
  jurisdictionalGroupId?: never;

  @Exclude()
  jurisdictionalGroup?: never;

  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  description?: string;

  @IsOptional()
  @IsUUID('all', { each: true })
  @ArrayNotEmpty()
  medicalUnitIds?: string[];

  @Exclude()
  isDefaultGroup?: never;

  @Exclude()
  medicalUnits?: never;
}
